import styled from 'styled-components';

export const customStyles = `
  overflow: scroll;
  max-height: 60%;
  width: 44%;
  position: fixed;
  margin-left: 28%;
  margin-top: 16.5%;
  top: 0;
  left: 0;
  background-color: white;`;

export const Input = styled.input`
  border: none;
  outline: none;
  font-size: 18px;
  flex: 1 1 auto;
  min-width: 140px;

  &:hover {
    border: 1px solid #b2d47e;
  }
`;

export const Tag = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: #eee;
  padding: 2px 8px;
  border-radius: 16px;
  margin-bottom: 6px;
  margin-right: 3px;
`;

export const RemoveTagButton = styled.button`
  margin-left: 4px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: #999;
  font-size: 12px;
  padding: 0;
`;

export const Spacer = styled.div`
  height: 8px;
`;
